var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 641.5",
    style: {
      enableBackground: "new 0 0 600 641.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,608.2L68.2,482.6C46.7,471,33.3,448.5,33.3,424V163.7 M300,608.2l231.8-125.5 c21.5-11.7,34.9-34.2,34.9-58.6V163.7 M300,608.2v-200 M33.3,163.7L269.2,40.9c19.3-10.1,42.3-10.1,61.6,0l235.9,122.8 M33.3,163.7 l178.7,96.8 M566.7,163.7l-178.7,96.8 M300,408.2c55.2,0,100-44.8,100-100c0-17.2-4.4-33.5-12.1-47.6 M300,408.2 c-55.2,0-100-44.8-100-100c0-17.2,4.4-33.5,12.1-47.6 M387.9,260.5c-16.9-31.2-50-52.4-87.9-52.4s-71,21.2-87.9,52.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIcon);
export default __webpack_public_path__ + "static/media/token_icon.896c048ad84766310085f6887e3b00ec.svg";
export { ForwardRef as ReactComponent };